import { Box, Typography } from '@mui/material'
import React from 'react'

const Scan = () => {
  return (
    <Box display={"flex"} flexDirection={"column"} alignItems={"center"} gap={1} p="10px">
        <Typography textAlign={"center"} fontSize={"20px"} color="#fff">اسکن کنید</Typography>
        <img src="/images/qrcode.png" alt=""  />
    </Box>
  )
}

export default Scan